import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledButton } from '../../../components';

interface HeaderProps {
	className?: string;
	buttonPlaceholder?: string;
	action?(...args: unknown[]): unknown;
	href?: string;
}

const Header = (props: HeaderProps) => {
	const { buttonPlaceholder, href, action } = props;
	const { t } = useTranslation();

	return (
		<div>
			<Grid alignItems='flex-end' container justifyContent='space-between' spacing={3}>
				<Grid item>
					<Typography component='h1' variant='h3'>
						{t('views.assets.page.title')}
					</Typography>
				</Grid>
				{buttonPlaceholder ?
					<Grid item>
						<StyledButton href={href} onClick={action} variant='contained-primary'>
							{buttonPlaceholder}
						</StyledButton>
					</Grid>
				:	null}
			</Grid>
		</div>
	);
};

export default Header;
